//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class ActivityStatusService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[ActivityStatus.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/activity-status/detail', {'params':params});
	};

	//GeneratorFlag:[ActivityStatus.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/activity-status/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}